
define('modules/application/wizard/steps/zoneStep/complexZoneStep/audioVideoZoneStep/zoneDetailView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  // Classes
  "../zoneDetailView",
  "../../../../classes/vdeExpansion",
  "../../../../classes/apartmentInterface",
  "../../../../classes/sources",
  "../../../../classes/vdes",
  "../../../../classes/touchScreen",
  "../../../../classes/mainCommand",
  "../../../../classes/amplifierRadioCommand",
  "../../../../classes/vpeDevices",
  "../../../../classes/webServer",
  "../../../../classes/handsets",
  "../../../../classes/vcts",
  "../../../../classes/telephony",
  "../../../../classes/amplifierAndLoudSpeakers",
  "../../../../classes/amplifierCommand",

  //Widgets
  "../../../../../widgets/audioVideoConsumptionIndicator"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneDetailView,
  vdeExpansion,
  apartmentInterface,
  sources,
  vdes,
  touchScreen,
  mainCommand,
  amplifierRadioCommand,
  vpeDevices,
  webServer,
  handsets,
  vcts,
  telephony,
  amplifierAndLoudSpeakers,
  amplifierCommand,
  audiovideoConsumptionIndicator) {

  // Creating a single zone model
  var audioVideoZoneDetailView               = ZoneDetailView.extend({
    addConstructors : function() {
      this.consumptionIndicator = audiovideoConsumptionIndicator;
    },
    sectionInstancer        : function(section)   {
      switch(section.name)
      {
        case "vdeExpansion"               : return vdeExpansion;
        case "apartmentInterface"         : return apartmentInterface;
        case "sources"                    : return sources;
        case "vdes"                       : return vdes;
        case "touchScreen"                : return touchScreen;
        case "mainCommand"                : return mainCommand;
        case "vpeDevices"                 : return vpeDevices;
        case "webServer"                  : return webServer;
        case "amplifierRadioCommand"      : return amplifierRadioCommand;
        case "handsets"                   : return handsets;
        case "vcts"                       : return vcts;
        case "telephony"                  : return telephony;
        case "amplifierAndLoudSpeakers"   : return amplifierAndLoudSpeakers;
        case "amplifierCommand"           : return amplifierCommand;
      }
    },

    beforeRender : function() {
      var consumptionIndicatorModel;

      //Adding current consumption indicator
      if (BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"))
        consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
      else
        consumptionIndicatorModel = new this.consumptionIndicator.Model();

     // this.insertView(".indicators", new this.consumptionIndicator.View({model : consumptionIndicatorModel}));
    }
  });

  // Required, return the module for AMD compliance
  return audioVideoZoneDetailView;
});